import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var FeatureToggleName;
(function (FeatureToggleName) {
    FeatureToggleName["ZERO_LAST_MINUTE_DISCOUNT"] = "ZERO_LAST_MINUTE_DISCOUNT";
    FeatureToggleName["TEMPORARY_ACCESS_MANAGEMENT"] = "TEMPORARY_ACCESS_MANAGEMENT";
    FeatureToggleName["ONLINE_POSITIONS_RENAME"] = "ONLINE_POSITIONS_RENAME";
    FeatureToggleName["MAILING_POSITIONS_RENAME"] = "MAILING_POSITIONS_RENAME";
    FeatureToggleName["PATH_DEFAULT_FRANKING_LICENCE"] = "PATH_DEFAULT_FRANKING_LICENCE";
    FeatureToggleName["INTERNAL_ACCOUNT"] = "INTERNAL_ACCOUNT";
    FeatureToggleName["INMAIL_CHANNEL"] = "INMAIL_CHANNEL";
    FeatureToggleName["FLAP_PROMOPOST_PRODUCT"] = "FLAP_PROMOPOST_PRODUCT";
    FeatureToggleName["REVISED_PROMOPOST_DELIVERY_DAYS"] = "REVISED_PROMOPOST_DELIVERY_DAYS";
    FeatureToggleName["POST_APP_ONLINE_INVENTORY"] = "POST_APP_ONLINE_INVENTORY";
    FeatureToggleName["ADDITIONAL_PROMOPOST_PRODUCTS"] = "ADDITIONAL_PROMOPOST_PRODUCTS";
    FeatureToggleName["REVISED_PROMOPOST_PRODUCTS_LIST"] = "REVISED_PROMOPOST_PRODUCTS_LIST";
    FeatureToggleName["POSTRON_MOBILE_IN_APP_DISPLAY_SUPPRESSION"] = "POSTRON_MOBILE_IN_APP_DISPLAY_SUPPRESSION";
    FeatureToggleName["MAILING_POSITIONS_CLONE"] = "MAILING_POSITIONS_CLONE";
    FeatureToggleName["RELOCATION_TARGETING"] = "RELOCATION_TARGETING";
    FeatureToggleName["ADDITIONAL_TARGETING_CRITERIA"] = "ADDITIONAL_TARGETING_CRITERIA";
    FeatureToggleName["DEAL_GROUPS"] = "DEAL_GROUPS";
    FeatureToggleName["MAILING_POSITION_POSTAL_CODES_EXCLUSION"] = "MAILING_POSITION_POSTAL_CODES_EXCLUSION";
    FeatureToggleName["ADDRESSED_MAILING_LETTER_PRODUCT_CHANGES"] = "ADDRESSED_MAILING_LETTER_PRODUCT_CHANGES";
    FeatureToggleName["PROMOPOST_HOLIDAY_ADJUSTMENTS"] = "PROMOPOST_HOLIDAY_ADJUSTMENTS";
    FeatureToggleName["CAR_SURVEY_TARGETING"] = "CAR_SURVEY_TARGETING";
    FeatureToggleName["ASYNC_CAMPAIGN_STAGE_CHANGE"] = "ASYNC_CAMPAIGN_STAGE_CHANGE";
    FeatureToggleName["OUTDATED_POSITIONS_BLOCKING"] = "OUTDATED_POSITIONS_BLOCKING";
    FeatureToggleName["FRODO_KAFKA_SWITCH_POST"] = "FRODO_KAFKA_SWITCH_POST";
    FeatureToggleName["FRODO_KAFKA_SWITCH_POSTNETZ"] = "FRODO_KAFKA_SWITCH_POSTNETZ";
})(FeatureToggleName || (FeatureToggleName = {}));
export var OwningService;
(function (OwningService) {
    OwningService["POST"] = "POST";
    OwningService["POST_CRM"] = "POST_CRM";
    OwningService["POSTNETZ_ANALOG"] = "POSTNETZ_ANALOG";
    OwningService["POSTNETZ_ANALOG_OPERATIONS"] = "POSTNETZ_ANALOG_OPERATIONS";
    OwningService["PERMISSIONS"] = "PERMISSIONS";
    OwningService["CRM"] = "CRM";
    OwningService["UNDEFINED"] = "UNDEFINED";
})(OwningService || (OwningService = {}));
